'use strict';

const ADD_ADDRESS = 'add-address';
const ADD_ADDRESS_ORDER = 'add-address-order';
const ADD_COMMENT = 'add-comment';
const ADD_COMMENT_NEWS = 'add-news-comment';
const ADD_ORDER_COMMENT = 'add-order-comment';
const ADD_ORDER_PARCEL_LOCKER = 'add-order-parcel-locker';
const ADD_PARCELLOCKER = 'add-parcellocker';
const ADD_PRIORITY = 'add-priority';
const ARTICLES = 'article';
const BESTSELLER = 'bestsellery';
const BUG_REPORT = 'bug-report';
const CART_ADD_PROMO = 'cart-add-promo';
const CART_CLEAN = 'cart-clean';
const CART_FROM_LIST = 'cart-from-list';
const CART_SAVE = 'cart-save';
const CART_SAVE_ADD = 'cart-save-add';
const CART_SAVE_CHANGE_NAME = 'cart-save-change-name';
const CATEGORIES = 'categories';
const CHANGE_ACCOUNT_DATA = 'change-account-data';
const CHANGE_CATEGORY_PRODUCT_AMOUNT = 'change-category-product-amount';
const CHANGE_EMAIL = 'change-email';
const CHANGE_ORDER_PAYMENT = 'change-order-payment';
const CHANGE_ORDER_SHIPMENT = 'change-order-shipment';
const CHANGE_PASSWORD = 'change-password';
const CHANGE_PROLINE_OFFICE = 'change-proline-office';
const CLIENT_APP_DATA = 'client-app-data';
const CONFIGURATOR = 'configurator';
const CONFIGURATOR_ASSEMBLY = 'configurator-assembly';
const CONFIGURATOR_OPTIONAL = 'configurator-optional';
const CONFIGURATOR_SIMPLY_URL = 'configurator-simply-url';
const CONSENTS = 'consents';
const DEFAULT_AMOUNT = 'default-amount';
const DEFAULT_PAYMENT = 'default-payment';
const DEFAULT_SHIPMENT = 'default-shipment';
const DEFAULT_SORTING = 'default-sorting';
const DELETE_ADDRESS = 'delete-address';
const DELIVERY_NOTIFICATION = 'delivery-notification';
const DESCRIPTION_ERROR_NOTE = 'description-error-note';
const EDIT_ADDRESS = 'edit-address';
const LIST_CHANGE_PRODUCT_AMOUNT = 'list-change-product-amount'
const LIST_DELETE = 'list-delete'
const LIST_DELETE_PRODUCT = 'list-delete-product';
const NEWSNEES = 'nowosci';
const ORDERS_FILTERING = 'orders-filtering';
const PERSONALIZATION = 'personalization';
const PRIVATE_LIST_TO_CART = 'private-list-to-cart';
const PRODUCERS = 'producers';
const PRODUCT_ADD = 'product-add';
const PRODUCT_ADD_SINGLE = 'product-add-single';
const PRODUCT_CHANGE = 'product-change';
const PRODUCT_REMOVE = 'product-remove';
const RECOMMENDED_PRODUCTS_TO_CART = 'recommended-products-to-cart';
const REDIRECT = 'redirect';
const REGISTER_NIP = 'register-nip';
const REGISTER_STAGE2 = 'register-stage2';
const RELOAD = 'reload';
const SALE = 'wyprzedaz';
const SEARCHER = 'wyszukaj';
const SEARCH_POST = 'search-post';
const SEND_QUESTION = 'send-question';
const SERVICE_ADD = 'service-add';
const SET_PRIMARY_ADDRESS = 'set-primary-address';
const SUMMARY_ORDER = 'summary-order';
const SWITCH_CUSTOMER = 'switch-customer';
const TOKEN_EXPIRED = 'token-expired';
const UPDATE_DELIVERY_ORDER_DATA = 'update-delivery-order-data';
const UPDATE_ORDER_COMMENT = 'update-order-comment';
const PAGINATION = 'pagination';

export {
    ADD_ADDRESS,
    ADD_ADDRESS_ORDER,
    ADD_COMMENT,
    ADD_COMMENT_NEWS,
    ADD_ORDER_COMMENT,
    ADD_ORDER_PARCEL_LOCKER,
    ADD_PARCELLOCKER,
    ADD_PRIORITY,
    ARTICLES,
    BESTSELLER,
    BUG_REPORT,
    CART_ADD_PROMO,
    CART_CLEAN,
    CART_FROM_LIST,
    CART_SAVE,
    CART_SAVE_ADD,
    CART_SAVE_CHANGE_NAME,
    CATEGORIES,
    CHANGE_ACCOUNT_DATA,
    CHANGE_CATEGORY_PRODUCT_AMOUNT,
    CHANGE_EMAIL,
    CHANGE_ORDER_PAYMENT,
    CHANGE_ORDER_SHIPMENT,
    CHANGE_PASSWORD,
    CHANGE_PROLINE_OFFICE,
    CLIENT_APP_DATA,
    CONFIGURATOR,
    CONFIGURATOR_ASSEMBLY,
    CONFIGURATOR_OPTIONAL,
    CONFIGURATOR_SIMPLY_URL,
    CONSENTS,
    DEFAULT_AMOUNT,
    DEFAULT_PAYMENT,
    DEFAULT_SHIPMENT,
    DEFAULT_SORTING,
    DELETE_ADDRESS,
    DELIVERY_NOTIFICATION,
    DESCRIPTION_ERROR_NOTE,
    EDIT_ADDRESS,
    LIST_CHANGE_PRODUCT_AMOUNT,
    LIST_DELETE,
    LIST_DELETE_PRODUCT,
    NEWSNEES,
    ORDERS_FILTERING,
    PERSONALIZATION,
    PRIVATE_LIST_TO_CART,
    PRODUCERS,
    PRODUCT_ADD,
    PRODUCT_ADD_SINGLE,
    PRODUCT_CHANGE,
    PRODUCT_REMOVE,
    RECOMMENDED_PRODUCTS_TO_CART,
    REDIRECT,
    REGISTER_NIP,
    REGISTER_STAGE2,
    RELOAD,
    SALE,
    SEARCHER,
    SEARCH_POST,
    SEND_QUESTION,
    SERVICE_ADD,
    SET_PRIMARY_ADDRESS,
    SUMMARY_ORDER,
    SWITCH_CUSTOMER,
    TOKEN_EXPIRED,
    UPDATE_DELIVERY_ORDER_DATA,
    UPDATE_ORDER_COMMENT,
    PAGINATION,
}
